// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"307d2bd9","498":"f21a7c2a","513":"84d8a075"}[chunkId] + ".chunk.js";
};